// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*=============================
  Mobile hardening
  -----------------------------
  Loaded last, after style.css and responsive.css.

  Most of this file exists because the pages are styled with React inline
  \`style\` objects, which no stylesheet can reach without \`!important\` and an
  attribute selector. Every rule here is scoped to a small-screen media query,
  so desktop rendering is untouched.
===============================*/

/* --------------------------------------------------------------------------
   1. Scroll-reveal safety net

   aos.css parks every [data-aos] element at opacity: 0 and only reveals it
   once AOS adds .aos-animate. Anything AOS fails to pick up — a lazy route, a
   section that renders after its fetch resolves — therefore stays invisible.
   On phones we do not want the animations at all, so pin the elements visible
   and let AOS's classes be a no-op.
   -------------------------------------------------------------------------- */
@media (max-width: 991.98px) {
  [data-aos],
  [data-aos][data-aos][data-aos] {
    opacity: 1 !important;
    transform: none !important;
    transition: none !important;
    animation: none !important;
    pointer-events: auto !important;
  }
}

@media (prefers-reduced-motion: reduce) {
  [data-aos],
  [data-aos][data-aos][data-aos] {
    opacity: 1 !important;
    transform: none !important;
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
  }
}

/* --------------------------------------------------------------------------
   2. No horizontal scroll, ever

   \`clip\` rather than \`hidden\` so we do not turn <html> into a scroll container
   and break position: sticky further up the page.
   -------------------------------------------------------------------------- */
@media (max-width: 991.98px) {
  /* On <html> only. Putting it on <body> as well makes both a scroll container
     and gives phones two competing scrollers. */
  html {
    overflow-x: hidden;
    overflow-x: clip;
    max-width: 100%;
  }

  body {
    max-width: 100%;
    overflow-wrap: break-word;
    word-break: break-word;
  }

  .fix,
  main.fix,
  section,
  footer,
  .container,
  .custom-container {
    max-width: 100%;
  }

  /* Bootstrap rows carry negative margins; without this the gutters spill. */
  .row {
    margin-left: -12px;
    margin-right: -12px;
  }
}

@media (max-width: 575.98px) {
  .container,
  .custom-container {
    padding-left: 16px;
    padding-right: 16px;
  }
}

/* --------------------------------------------------------------------------
   3. Media never overflows its column
   -------------------------------------------------------------------------- */
img,
svg,
video,
canvas,
iframe {
  max-width: 100%;
}

@media (max-width: 767.98px) {
  /* Once max-width kicks in, an image with only a width attribute would squash
     unless the height follows. Images that set their own height — avatars,
     object-fit crops — are left alone. */
  img:not([style*="height"]):not([height]):not([class]) {
    height: auto;
  }

  iframe {
    width: 100%;
  }
}

/* --------------------------------------------------------------------------
   4. Inline CSS grids collapse instead of squeezing

   Admin screens and several public sections hard-code \`repeat(3, 1fr)\` /
   \`repeat(4, 1fr)\` / \`1fr 1fr 340px\` inline. Grids that already use auto-fit or
   auto-fill are responsive on their own and are left alone.
   -------------------------------------------------------------------------- */
@media (max-width: 991.98px) {
  [style*="grid-template-columns"]:not([style*="auto-fit"]):not([style*="auto-fill"]) {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}

@media (max-width: 575.98px) {
  [style*="grid-template-columns"]:not([style*="auto-fit"]):not([style*="auto-fill"]) {
    grid-template-columns: minmax(0, 1fr) !important;
  }
}

/* --------------------------------------------------------------------------
   5. Inline flex rows wrap

   Applies only to row-direction containers — wrapping a column-direction flex
   container would spill its children into extra columns instead.
   \`flex-wrap\` only takes effect once the row would otherwise overflow, so this
   is inert on rows that already fit.
   -------------------------------------------------------------------------- */
@media (max-width: 767.98px) {
  [style*="display: flex"]:not([style*="flex-direction: column"]):not([style*="flex-wrap: nowrap"]) {
    flex-wrap: wrap;
  }

  /* Fixed-width children inside those rows must be allowed to shrink. */
  [style*="min-width"]:not(input):not(select):not(textarea) {
    max-width: 100%;
  }
}

/* --------------------------------------------------------------------------
   6. Sticky rails become normal flow

   Several detail pages pin a sidebar with \`position: sticky; top: 100px\`.
   Stacked on a phone that rail sits at the bottom of a full-width column, where
   sticking to the viewport just leaves a floating box over the footer.
   -------------------------------------------------------------------------- */
@media (max-width: 991.98px) {
  /* \`top: 0\` is the modal-header case — a title bar pinned inside its own
     scrolling panel, which is still the right behaviour on a phone. Everything
     else is a page rail offset below the site header. */
  [style*="position: sticky"]:not([style*="top: 0"]) {
    position: static !important;
  }
}

/* --------------------------------------------------------------------------
   7. Forms

   16px is the threshold below which iOS Safari zooms the viewport on focus and
   never zooms back out — the single most common "the site broke" report on
   iPhone. Inline font sizes of 13-14px are overridden here on small screens
   only.
   -------------------------------------------------------------------------- */
@media (max-width: 767.98px) {
  input:not([type="checkbox"]):not([type="radio"]),
  select,
  textarea {
    font-size: 16px !important;
    max-width: 100%;
    min-width: 0 !important;
  }

  input:not([type="checkbox"]):not([type="radio"]):not([type="file"]),
  select,
  textarea {
    width: 100%;
  }

  /* A search box and its filter dropdown sit in the same inline flex row on the
     directory pages; each needs the full width once they stack. */
  [style*="display: flex"] > input:not([type="checkbox"]):not([type="radio"]),
  [style*="display: flex"] > select {
    flex: 1 1 100% !important;
  }

  label {
    max-width: 100%;
  }
}

/* --------------------------------------------------------------------------
   8. Tap targets and buttons
   -------------------------------------------------------------------------- */
@media (max-width: 767.98px) {
  .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 44px;
    max-width: 100%;
    white-space: normal;
    text-align: center;
  }

  button,
  a.btn,
  [role="button"] {
    touch-action: manipulation;
  }
}

/* --------------------------------------------------------------------------
   9. Header

   The static header is \`position: fixed\`, so the page needs a spacer exactly as
   tall as the header. That spacer used to be a hard-coded 100px / 70px, which
   never matched the real height once the top bar wrapped — content slid under
   the header. \`useHeaderSpacer\` now measures it and writes --header-height, and
   this rule consumes it. The literal heights stay as the pre-measurement
   fallback.
   -------------------------------------------------------------------------- */
.header-spacer {
  height: var(--header-height, 100px);
}

@media (max-width: 767.98px) {
  .header-spacer {
    height: var(--header-height, 86px) !important;
  }

  /* Tagline is already hidden here and only social icons remain, so the whole
     bar is dead height on a phone. */
  .heder-top-wrap {
    display: none;
  }
}

@media (max-width: 991.98px) {
  /* Sign in / Join move into the slide-out menu below 992px, where the nav
     itself is already collapsed. Keeping them in the bar crowds the logo. */
  .menu-area .header-action {
    display: none !important;
  }

  .menu-nav {
    align-items: center;
    gap: 12px;
  }

  .logo img {
    max-height: 40px;
    width: auto;
  }
}

/* The toggler is floated right against the logo row; keep the float, just give
   it a finger-sized hit area. */
@media (max-width: 991.98px) {
  .menu-area .mobile-nav-toggler {
    min-width: 46px;
    min-height: 42px;
    line-height: 30px;
    text-align: center;
  }
}

/* --------------------------------------------------------------------------
   10. Slide-out mobile menu
   -------------------------------------------------------------------------- */
.mobile-menu {
  width: min(320px, 88vw);
}

.mobile-menu .menu-box {
  padding-bottom: 40px;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}

.mobile-menu .mobile-auth-actions {
  padding: 20px 25px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.mobile-menu .mobile-auth-actions .btn {
  width: 100%;
  justify-content: center;
  min-height: 46px;
}

.mobile-menu .mobile-auth-user {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 25px;
  border-top: 1px solid rgba(10, 22, 40, 0.08);
  border-bottom: 1px solid rgba(10, 22, 40, 0.08);
  margin-bottom: 8px;
}

.mobile-menu .mobile-auth-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #c6a962;
  color: #fff;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* Keep the drawer above the fixed page header it is rendered inside — and keep
   the backdrop strictly below the drawer. The backdrop is the later sibling in
   the DOM, so an equal z-index paints it over the menu, which both hides the
   panel and swallows every tap on it. */
.mobile-menu {
  z-index: 9999;
}

.menu-backdrop {
  z-index: 9998;
}

/* overflow: hidden is the scroll lock. \`touch-action: none\` here would also
   kill touch scrolling inside the drawer itself.
   It has to land on <html> as well: once html carries the overflow-x above it
   is no longer \`visible\`, so body's overflow stops propagating to the viewport
   and locking body alone leaves the page scrolling behind the drawer. */
html.mobile-menu-visible,
body.mobile-menu-visible {
  overflow: hidden;
}

/* --------------------------------------------------------------------------
   11. Hero

   100vh on a phone measures the viewport with the browser chrome retracted, so
   the hero is taller than the screen and the section below never peeks.
   -------------------------------------------------------------------------- */
@media (max-width: 991.98px) {
  /* The home header overlays the hero instead of using .header-spacer, so the
     hero has to reserve the header's height itself. */
  .banner-area-two {
    padding-top: calc(var(--header-height, 86px) + 28px) !important;
  }
}

@media (max-width: 767.98px) {
  .banner-area-two {
    min-height: 100svh !important;
  }

  .banner-content-two .banner-btn {
    justify-content: flex-start;
  }

  .banner-content-two .banner-btn .btn {
    flex: 1 1 100%;
  }
}

/* --------------------------------------------------------------------------
   12. Full-screen overlays and modals

   The modal shells are inline \`position: fixed\` flex centring boxes with 20px
   padding and a panel capped at 90vh. On a phone the padding is wasted width
   and the panel needs to be able to scroll to its own bottom.
   -------------------------------------------------------------------------- */
@media (max-width: 767.98px) {
  [style*="position: fixed"][style*="display: flex"]:not(.admin-sidebar):not([style*="flex-direction: column"]) {
    padding: 12px !important;
    align-items: flex-start !important;
    overflow-y: auto !important;
  }

  [style*="max-height: 90vh"] {
    max-height: calc(100dvh - 24px) !important;
  }

  /* Expert profile's modal and cards are declared in a \\3c style> tag rather than
     inline, so the attribute selectors above cannot reach them. */
  .expert-modal-bg {
    padding: 12px !important;
    align-items: flex-start !important;
    overflow-y: auto !important;
  }

  .expert-modal-box {
    max-height: calc(100dvh - 24px);
    overflow-y: auto;
  }

  .expert-card,
  .expert-sidebar-card {
    padding: 20px !important;
  }
}

/* --------------------------------------------------------------------------
   13. Wide content scrolls inside its own box rather than the page
   -------------------------------------------------------------------------- */
@media (max-width: 991.98px) {
  [style*="overflow-x: auto"] {
    -webkit-overflow-scrolling: touch;
  }

  table {
    max-width: 100%;
  }

  pre,
  code {
    white-space: pre-wrap;
    word-break: break-word;
  }
}

/* --------------------------------------------------------------------------
   14. Admin shell

   The sidebar is \`position: fixed; width: 270px\` with the main column pushed
   over by an equal margin. On a 375px screen that leaves ~105px of content.
   AdminLayout now drives these classes to run the sidebar as a drawer.
   -------------------------------------------------------------------------- */
@media (max-width: 991.98px) {
  .admin-shell {
    display: block !important;
  }

  .admin-sidebar {
    transform: translateX(-100%);
    transition: transform 0.28s ease !important;
    width: 270px !important;
  }

  .admin-shell.admin-sidebar-open .admin-sidebar {
    transform: translateX(0);
  }

  .admin-main {
    margin-left: 0 !important;
  }

  .admin-topbar {
    padding: 0 16px !important;
    /* Below the drawer backdrop (999). At an equal z-index the topbar is the
       later element in the DOM and would show through the dim overlay. */
    z-index: 998 !important;
  }

  .admin-content {
    padding: 20px 16px !important;
  }

  .admin-sidebar-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(10, 22, 40, 0.5);
    z-index: 999;
  }
}

@media (min-width: 992px) {
  .admin-sidebar-toggle,
  .admin-sidebar-backdrop {
    display: none !important;
  }
}

/* --------------------------------------------------------------------------
   15. Footer
   -------------------------------------------------------------------------- */
@media (max-width: 767.98px) {
  .footer-area .row > [class*="col-"] {
    margin-bottom: 28px;
  }

  .footer-area .row > [class*="col-"]:last-child {
    margin-bottom: 0;
  }

  .footer-bottom {
    text-align: center;
  }
}

/* --------------------------------------------------------------------------
   16. Typography ceilings

   A few headings are hard-coded at 28-44px inline. clamp() would be better at
   the source, but these keep long words from forcing a scrollbar meanwhile.
   -------------------------------------------------------------------------- */
@media (max-width: 575.98px) {
  h1 {
    font-size: min(2rem, 9vw);
  }

  h2 {
    font-size: min(1.75rem, 8vw);
  }

  h3 {
    font-size: min(1.5rem, 7vw);
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  span,
  a {
    overflow-wrap: break-word;
  }
}

/* --------------------------------------------------------------------------
   17. Home screen: compact cards

   Every home section was laid out for a desktop column and then handed the
   full width of a phone: one 380px-tall expert portrait per screenful, one
   stat tile with a 46px numeral, an event row whose date block, title and type
   pill all fought for 340px. The markup now puts experts and stats two to a
   row on phones; the sizes below are what make two-up actually fit.
   -------------------------------------------------------------------------- */
@media (max-width: 767.98px) {
  /* Sections are individually padded inline at clamp(48px, 6vw, 72px); the
     lower bound is still a lot of dead space between short cards. */
  .home-card-grid > [class*="col-"] {
    margin-bottom: 14px !important;
  }
}

@media (max-width: 575.98px) {
  /* Portrait cards: shorter, and the plate carries the name only. Everything
     else lives behind the tap — see the note at the top of PersonCard.jsx. */
  /* Taller than it is wide, so the crop is portrait-shaped and a headshot
     has room to be a headshot: ~152x209 on a 360px phone. */
  .person-card {
    height: clamp(200px, 58vw, 260px) !important;
    border-radius: 8px;
  }

  .person-card__plate {
    padding: 8px 12px 10px !important;
  }

  /* At two per row the card is ~150px wide on a 360px phone. A single
     ellipsised line turns most names into "Mukund Sahasrab…", so the name
     wraps to two lines — the plate is only carrying the name here, so it can
     afford the second one without creeping up over the face. */
  .person-card__name {
    font-size: 14px !important;
    line-height: 1.25;
    white-space: normal !important;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .person-card__badge {
    top: 8px !important;
    left: 8px !important;
    padding: 4px 8px !important;
    font-size: 8px !important;
  }

  .person-card__monogram {
    font-size: 40px !important;
  }

  /* Stat tiles: two per row, so the padding and numeral both come down. */
  .home-stat-card {
    padding: 18px 10px !important;
    border-radius: 12px !important;
  }

  .home-stat-card .count {
    font-size: 30px !important;
    margin-bottom: 4px !important;
  }

  .home-stat-card p {
    font-size: 10px !important;
    letter-spacing: 1px !important;
    line-height: 1.35;
  }

  /* Event rows: the date block and the type pill move onto one line under the
     title instead of squeezing it into a third of the width. */
  .home-events-list {
    gap: 12px !important;
  }

  .home-event-card {
    align-items: flex-start !important;
    flex-wrap: wrap;
    gap: 12px !important;
    padding: 14px 14px !important;
    border-radius: 10px;
  }

  .home-event-date {
    width: 52px !important;
    height: 52px !important;
    border-radius: 10px !important;
  }

  .home-event-date span:first-child {
    font-size: 18px !important;
  }

  .home-event-date span:last-child {
    font-size: 9px !important;
    letter-spacing: 1px !important;
  }

  .home-event-body {
    /* Without a basis the flex child refuses to wrap a long venue name. */
    flex: 1 1 60% !important;
    min-width: 0;
  }

  .home-event-body h4 {
    font-size: 15px !important;
    margin-bottom: 4px !important;
  }

  .home-event-body p {
    font-size: 11px !important;
  }

  .home-event-type {
    flex: 1 1 100%;
  }

  .home-event-type span {
    padding: 5px 12px !important;
    font-size: 9px !important;
    letter-spacing: 1px !important;
  }

  /* Testimonials: one per row, but not with desktop padding. */
  .home-testimonial-col > div {
    padding: 18px 16px !important;
  }
}

/* --------------------------------------------------------------------------
   18. Touch feedback

   suppressTouchHover.js stops tapped cards latching into a hover state, which
   leaves them with no press feedback at all. These :active rules put it back —
   a quick, cheap depress that ends the moment the finger lifts, unlike a
   JavaScript hover flag that has nothing to switch it off.
   -------------------------------------------------------------------------- */
@media (hover: none) {
  .person-card,
  .home-event-card,
  .home-stat-card,
  .btn,
  button:not(:disabled),
  [role="button"] {
    -webkit-tap-highlight-color: rgba(198, 169, 98, 0.18);
  }

  .person-card:active,
  .home-event-card:active,
  .home-stat-card:active {
    transform: scale(0.985) !important;
    transition: transform 0.12s ease !important;
  }

  .btn:active,
  button:not(:disabled):active {
    transform: scale(0.97);
    transition: transform 0.12s ease;
  }

  /* The person cards deliberately do NOT reopen their detail plate here: it
     is tall enough to cover the face. The card is a link to the full profile,
     which is where the role, company and bio belong on a phone. */
}

/* --------------------------------------------------------------------------
   19. Notch and home-indicator safe areas

   Fixed elements sat under the iOS home indicator and behind the notch in
   landscape. env() resolves to 0 everywhere else, so this is inert on Android
   and desktop.
   -------------------------------------------------------------------------- */
@supports (padding: max(0px)) {
  @media (max-width: 991.98px) {
    body {
      padding-bottom: env(safe-area-inset-bottom);
    }

    .admin-topbar {
      padding-top: max(12px, env(safe-area-inset-top));
    }
  }

  /* Matches the 16px gutter set in section 2, so only the notch adds to it. */
  @media (max-width: 575.98px) {
    .container,
    .custom-container {
      padding-left: max(16px, env(safe-area-inset-left));
      padding-right: max(16px, env(safe-area-inset-right));
    }
  }
}

/* --------------------------------------------------------------------------
   20. Directory cards at two per row

   The experts, advisory and partner grids now use col-6 on phones (they were
   full width, one card per screenful). Section 17 already sizes the person
   cards; this does the same for the partner card, whose logo and company name
   have no room to sit side by side in a 150px column.
   -------------------------------------------------------------------------- */
@media (max-width: 575.98px) {
  .partner-card {
    padding: 12px !important;
    gap: 8px !important;
  }

  .partner-card__head {
    align-items: flex-start !important;
    flex-direction: column;
    gap: 8px !important;
  }

  .partner-card__head > div:first-child {
    width: 40px !important;
    height: 40px !important;
  }

  .partner-card h5 {
    font-size: 13px !important;
  }

  .partner-card p {
    font-size: 11px !important;
    line-height: 1.5 !important;
    -webkit-line-clamp: 2 !important;
  }

  .partner-card span {
    font-size: 10px !important;
  }
}

/* --------------------------------------------------------------------------
   21. Admin tables scroll instead of crushing

   The admin lists are five to eight column tables inside a card that carries
   \`overflow: hidden\` inline for its rounded corners. On a phone that clipped
   the table and squeezed every column to a couple of characters, with no way
   to reach the rest of the row. The card now scrolls sideways and the table
   keeps a readable minimum width.
   -------------------------------------------------------------------------- */
@media (max-width: 991.98px) {
  .admin-table-wrap {
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch;
  }

  .admin-table {
    min-width: 760px;
  }

  .admin-table th,
  .admin-table td {
    white-space: nowrap;
  }
}

@media (max-width: 575.98px) {
  /* Admin cards in a two-up grid: the inline padding is desktop-sized. */
  .admin-content [style*="border-radius: 8px"][style*="padding"] {
    overflow-wrap: break-word;
  }

  /* Dialogs on admin screens are 720px wide with 28px of padding, which leaves
     a phone about 280px of usable form. */
  .admin-content + div [style*="max-width: 720px"],
  [style*="z-index: 9999"] > [style*="max-width: 720px"] {
    padding: 18px !important;
    max-height: 92vh !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/mobile.css"],"names":[],"mappings":"AAAA;;;;;;;;;gCASgC;;AAEhC;;;;;;;;+EAQ+E;AAC/E;EACE;;IAEE,qBAAqB;IACrB,0BAA0B;IAC1B,2BAA2B;IAC3B,0BAA0B;IAC1B,+BAA+B;EACjC;AACF;;AAEA;EACE;;IAEE,qBAAqB;IACrB,0BAA0B;IAC1B,sCAAsC;IACtC,qCAAqC;EACvC;AACF;;AAEA;;;;;+EAK+E;AAC/E;EACE;gDAC8C;EAC9C;IACE,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;;;;;;IAME,eAAe;EACjB;;EAEA,2EAA2E;EAC3E;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;;+EAE+E;AAC/E;;;;;EAKE,eAAe;AACjB;;AAEA;EACE;;yCAEuC;EACvC;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;;;;;+EAM+E;AAC/E;EACE;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;;;;;;;+EAO+E;AAC/E;EACE;IACE,eAAe;EACjB;;EAEA,sEAAsE;EACtE;IACE,eAAe;EACjB;AACF;;AAEA;;;;;;+EAM+E;AAC/E;EACE;;wDAEsD;EACtD;IACE,2BAA2B;EAC7B;AACF;;AAEA;;;;;;;+EAO+E;AAC/E;EACE;;;IAGE,0BAA0B;IAC1B,eAAe;IACf,uBAAuB;EACzB;;EAEA;;;IAGE,WAAW;EACb;;EAEA;kEACgE;EAChE;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;+EAE+E;AAC/E;EACE;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;;;IAGE,0BAA0B;EAC5B;AACF;;AAEA;;;;;;;;;+EAS+E;AAC/E;EACE,mCAAmC;AACrC;;AAEA;EACE;IACE,6CAA6C;EAC/C;;EAEA;qCACmC;EACnC;IACE,aAAa;EACf;AACF;;AAEA;EACE;4EAC0E;EAC1E;IACE,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;AACF;;AAEA;gCACgC;AAChC;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;;+EAE+E;AAC/E;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4CAA4C;EAC5C,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;;wCAGwC;AACxC;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;;;wEAIwE;AACxE;;EAEE,gBAAgB;AAClB;;AAEA;;;;;+EAK+E;AAC/E;EACE;sDACoD;EACpD;IACE,+DAA+D;EACjE;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;;;;;;+EAM+E;AAC/E;EACE;IACE,wBAAwB;IACxB,kCAAkC;IAClC,2BAA2B;EAC7B;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;kEACgE;EAChE;IACE,wBAAwB;IACxB,kCAAkC;IAClC,2BAA2B;EAC7B;;EAEA;IACE,+BAA+B;IAC/B,gBAAgB;EAClB;;EAEA;;IAEE,wBAAwB;EAC1B;AACF;;AAEA;;+EAE+E;AAC/E;EACE;IACE,iCAAiC;EACnC;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;;;;;;+EAM+E;AAC/E;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;IAC5B,2CAA2C;IAC3C,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;IAC1B;yEACqE;IACrE,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,iCAAiC;IACjC,YAAY;EACd;AACF;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;AACF;;AAEA;;+EAE+E;AAC/E;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;;;;;+EAK+E;AAC/E;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;;;;;;;;IASE,yBAAyB;EAC3B;AACF;;AAEA;;;;;;;;+EAQ+E;AAC/E;EACE;oEACkE;EAClE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;6EAC2E;EAC3E;4DAC0D;EAC1D;IACE,4CAA4C;IAC5C,kBAAkB;EACpB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;;;+DAG6D;EAC7D;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,8BAA8B;IAC9B,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;EAC9B;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,wEAAwE;EACxE;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;+DAC6D;EAC7D;IACE,oBAAoB;EACtB;;EAEA;IACE,kCAAkC;IAClC,eAAe;IACf,oBAAoB;IACpB,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;EAChC;;EAEA;IACE,sEAAsE;IACtE,wBAAwB;IACxB,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,yBAAyB;IACzB,8BAA8B;EAChC;;EAEA,6DAA6D;EAC7D;IACE,6BAA6B;EAC/B;AACF;;AAEA;;;;;;;+EAO+E;AAC/E;EACE;;;;;;IAME,qDAAqD;EACvD;;EAEA;;;IAGE,kCAAkC;IAClC,2CAA2C;EAC7C;;EAEA;;IAEE,sBAAsB;IACtB,gCAAgC;EAClC;;EAEA;;kEAEgE;AAClE;;AAEA;;;;;;+EAM+E;AAC/E;EACE;IACE;MACE,2CAA2C;IAC7C;;IAEA;MACE,gDAAgD;IAClD;EACF;;EAEA,4EAA4E;EAC5E;IACE;;MAEE,kDAAkD;MAClD,oDAAoD;IACtD;EACF;AACF;;AAEA;;;;;;;+EAO+E;AAC/E;EACE;IACE,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,kCAAkC;IAClC,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,gCAAgC;EAClC;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;;;;;;;;+EAQ+E;AAC/E;EACE;IACE,2BAA2B;IAC3B,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE,uEAAuE;EACvE;IACE,yBAAyB;EAC3B;;EAEA;0CACwC;EACxC;;IAEE,wBAAwB;IACxB,2BAA2B;EAC7B;AACF","sourcesContent":["/*=============================\n  Mobile hardening\n  -----------------------------\n  Loaded last, after style.css and responsive.css.\n\n  Most of this file exists because the pages are styled with React inline\n  `style` objects, which no stylesheet can reach without `!important` and an\n  attribute selector. Every rule here is scoped to a small-screen media query,\n  so desktop rendering is untouched.\n===============================*/\n\n/* --------------------------------------------------------------------------\n   1. Scroll-reveal safety net\n\n   aos.css parks every [data-aos] element at opacity: 0 and only reveals it\n   once AOS adds .aos-animate. Anything AOS fails to pick up — a lazy route, a\n   section that renders after its fetch resolves — therefore stays invisible.\n   On phones we do not want the animations at all, so pin the elements visible\n   and let AOS's classes be a no-op.\n   -------------------------------------------------------------------------- */\n@media (max-width: 991.98px) {\n  [data-aos],\n  [data-aos][data-aos][data-aos] {\n    opacity: 1 !important;\n    transform: none !important;\n    transition: none !important;\n    animation: none !important;\n    pointer-events: auto !important;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  [data-aos],\n  [data-aos][data-aos][data-aos] {\n    opacity: 1 !important;\n    transform: none !important;\n    transition-duration: 0.01ms !important;\n    animation-duration: 0.01ms !important;\n  }\n}\n\n/* --------------------------------------------------------------------------\n   2. No horizontal scroll, ever\n\n   `clip` rather than `hidden` so we do not turn <html> into a scroll container\n   and break position: sticky further up the page.\n   -------------------------------------------------------------------------- */\n@media (max-width: 991.98px) {\n  /* On <html> only. Putting it on <body> as well makes both a scroll container\n     and gives phones two competing scrollers. */\n  html {\n    overflow-x: hidden;\n    overflow-x: clip;\n    max-width: 100%;\n  }\n\n  body {\n    max-width: 100%;\n    overflow-wrap: break-word;\n    word-break: break-word;\n  }\n\n  .fix,\n  main.fix,\n  section,\n  footer,\n  .container,\n  .custom-container {\n    max-width: 100%;\n  }\n\n  /* Bootstrap rows carry negative margins; without this the gutters spill. */\n  .row {\n    margin-left: -12px;\n    margin-right: -12px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .container,\n  .custom-container {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n}\n\n/* --------------------------------------------------------------------------\n   3. Media never overflows its column\n   -------------------------------------------------------------------------- */\nimg,\nsvg,\nvideo,\ncanvas,\niframe {\n  max-width: 100%;\n}\n\n@media (max-width: 767.98px) {\n  /* Once max-width kicks in, an image with only a width attribute would squash\n     unless the height follows. Images that set their own height — avatars,\n     object-fit crops — are left alone. */\n  img:not([style*=\"height\"]):not([height]):not([class]) {\n    height: auto;\n  }\n\n  iframe {\n    width: 100%;\n  }\n}\n\n/* --------------------------------------------------------------------------\n   4. Inline CSS grids collapse instead of squeezing\n\n   Admin screens and several public sections hard-code `repeat(3, 1fr)` /\n   `repeat(4, 1fr)` / `1fr 1fr 340px` inline. Grids that already use auto-fit or\n   auto-fill are responsive on their own and are left alone.\n   -------------------------------------------------------------------------- */\n@media (max-width: 991.98px) {\n  [style*=\"grid-template-columns\"]:not([style*=\"auto-fit\"]):not([style*=\"auto-fill\"]) {\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n  }\n}\n\n@media (max-width: 575.98px) {\n  [style*=\"grid-template-columns\"]:not([style*=\"auto-fit\"]):not([style*=\"auto-fill\"]) {\n    grid-template-columns: minmax(0, 1fr) !important;\n  }\n}\n\n/* --------------------------------------------------------------------------\n   5. Inline flex rows wrap\n\n   Applies only to row-direction containers — wrapping a column-direction flex\n   container would spill its children into extra columns instead.\n   `flex-wrap` only takes effect once the row would otherwise overflow, so this\n   is inert on rows that already fit.\n   -------------------------------------------------------------------------- */\n@media (max-width: 767.98px) {\n  [style*=\"display: flex\"]:not([style*=\"flex-direction: column\"]):not([style*=\"flex-wrap: nowrap\"]) {\n    flex-wrap: wrap;\n  }\n\n  /* Fixed-width children inside those rows must be allowed to shrink. */\n  [style*=\"min-width\"]:not(input):not(select):not(textarea) {\n    max-width: 100%;\n  }\n}\n\n/* --------------------------------------------------------------------------\n   6. Sticky rails become normal flow\n\n   Several detail pages pin a sidebar with `position: sticky; top: 100px`.\n   Stacked on a phone that rail sits at the bottom of a full-width column, where\n   sticking to the viewport just leaves a floating box over the footer.\n   -------------------------------------------------------------------------- */\n@media (max-width: 991.98px) {\n  /* `top: 0` is the modal-header case — a title bar pinned inside its own\n     scrolling panel, which is still the right behaviour on a phone. Everything\n     else is a page rail offset below the site header. */\n  [style*=\"position: sticky\"]:not([style*=\"top: 0\"]) {\n    position: static !important;\n  }\n}\n\n/* --------------------------------------------------------------------------\n   7. Forms\n\n   16px is the threshold below which iOS Safari zooms the viewport on focus and\n   never zooms back out — the single most common \"the site broke\" report on\n   iPhone. Inline font sizes of 13-14px are overridden here on small screens\n   only.\n   -------------------------------------------------------------------------- */\n@media (max-width: 767.98px) {\n  input:not([type=\"checkbox\"]):not([type=\"radio\"]),\n  select,\n  textarea {\n    font-size: 16px !important;\n    max-width: 100%;\n    min-width: 0 !important;\n  }\n\n  input:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"file\"]),\n  select,\n  textarea {\n    width: 100%;\n  }\n\n  /* A search box and its filter dropdown sit in the same inline flex row on the\n     directory pages; each needs the full width once they stack. */\n  [style*=\"display: flex\"] > input:not([type=\"checkbox\"]):not([type=\"radio\"]),\n  [style*=\"display: flex\"] > select {\n    flex: 1 1 100% !important;\n  }\n\n  label {\n    max-width: 100%;\n  }\n}\n\n/* --------------------------------------------------------------------------\n   8. Tap targets and buttons\n   -------------------------------------------------------------------------- */\n@media (max-width: 767.98px) {\n  .btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 44px;\n    max-width: 100%;\n    white-space: normal;\n    text-align: center;\n  }\n\n  button,\n  a.btn,\n  [role=\"button\"] {\n    touch-action: manipulation;\n  }\n}\n\n/* --------------------------------------------------------------------------\n   9. Header\n\n   The static header is `position: fixed`, so the page needs a spacer exactly as\n   tall as the header. That spacer used to be a hard-coded 100px / 70px, which\n   never matched the real height once the top bar wrapped — content slid under\n   the header. `useHeaderSpacer` now measures it and writes --header-height, and\n   this rule consumes it. The literal heights stay as the pre-measurement\n   fallback.\n   -------------------------------------------------------------------------- */\n.header-spacer {\n  height: var(--header-height, 100px);\n}\n\n@media (max-width: 767.98px) {\n  .header-spacer {\n    height: var(--header-height, 86px) !important;\n  }\n\n  /* Tagline is already hidden here and only social icons remain, so the whole\n     bar is dead height on a phone. */\n  .heder-top-wrap {\n    display: none;\n  }\n}\n\n@media (max-width: 991.98px) {\n  /* Sign in / Join move into the slide-out menu below 992px, where the nav\n     itself is already collapsed. Keeping them in the bar crowds the logo. */\n  .menu-area .header-action {\n    display: none !important;\n  }\n\n  .menu-nav {\n    align-items: center;\n    gap: 12px;\n  }\n\n  .logo img {\n    max-height: 40px;\n    width: auto;\n  }\n}\n\n/* The toggler is floated right against the logo row; keep the float, just give\n   it a finger-sized hit area. */\n@media (max-width: 991.98px) {\n  .menu-area .mobile-nav-toggler {\n    min-width: 46px;\n    min-height: 42px;\n    line-height: 30px;\n    text-align: center;\n  }\n}\n\n/* --------------------------------------------------------------------------\n   10. Slide-out mobile menu\n   -------------------------------------------------------------------------- */\n.mobile-menu {\n  width: min(320px, 88vw);\n}\n\n.mobile-menu .menu-box {\n  padding-bottom: 40px;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n}\n\n.mobile-menu .mobile-auth-actions {\n  padding: 20px 25px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.mobile-menu .mobile-auth-actions .btn {\n  width: 100%;\n  justify-content: center;\n  min-height: 46px;\n}\n\n.mobile-menu .mobile-auth-user {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 25px;\n  border-top: 1px solid rgba(10, 22, 40, 0.08);\n  border-bottom: 1px solid rgba(10, 22, 40, 0.08);\n  margin-bottom: 8px;\n}\n\n.mobile-menu .mobile-auth-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #c6a962;\n  color: #fff;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n/* Keep the drawer above the fixed page header it is rendered inside — and keep\n   the backdrop strictly below the drawer. The backdrop is the later sibling in\n   the DOM, so an equal z-index paints it over the menu, which both hides the\n   panel and swallows every tap on it. */\n.mobile-menu {\n  z-index: 9999;\n}\n\n.menu-backdrop {\n  z-index: 9998;\n}\n\n/* overflow: hidden is the scroll lock. `touch-action: none` here would also\n   kill touch scrolling inside the drawer itself.\n   It has to land on <html> as well: once html carries the overflow-x above it\n   is no longer `visible`, so body's overflow stops propagating to the viewport\n   and locking body alone leaves the page scrolling behind the drawer. */\nhtml.mobile-menu-visible,\nbody.mobile-menu-visible {\n  overflow: hidden;\n}\n\n/* --------------------------------------------------------------------------\n   11. Hero\n\n   100vh on a phone measures the viewport with the browser chrome retracted, so\n   the hero is taller than the screen and the section below never peeks.\n   -------------------------------------------------------------------------- */\n@media (max-width: 991.98px) {\n  /* The home header overlays the hero instead of using .header-spacer, so the\n     hero has to reserve the header's height itself. */\n  .banner-area-two {\n    padding-top: calc(var(--header-height, 86px) + 28px) !important;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .banner-area-two {\n    min-height: 100svh !important;\n  }\n\n  .banner-content-two .banner-btn {\n    justify-content: flex-start;\n  }\n\n  .banner-content-two .banner-btn .btn {\n    flex: 1 1 100%;\n  }\n}\n\n/* --------------------------------------------------------------------------\n   12. Full-screen overlays and modals\n\n   The modal shells are inline `position: fixed` flex centring boxes with 20px\n   padding and a panel capped at 90vh. On a phone the padding is wasted width\n   and the panel needs to be able to scroll to its own bottom.\n   -------------------------------------------------------------------------- */\n@media (max-width: 767.98px) {\n  [style*=\"position: fixed\"][style*=\"display: flex\"]:not(.admin-sidebar):not([style*=\"flex-direction: column\"]) {\n    padding: 12px !important;\n    align-items: flex-start !important;\n    overflow-y: auto !important;\n  }\n\n  [style*=\"max-height: 90vh\"] {\n    max-height: calc(100dvh - 24px) !important;\n  }\n\n  /* Expert profile's modal and cards are declared in a <style> tag rather than\n     inline, so the attribute selectors above cannot reach them. */\n  .expert-modal-bg {\n    padding: 12px !important;\n    align-items: flex-start !important;\n    overflow-y: auto !important;\n  }\n\n  .expert-modal-box {\n    max-height: calc(100dvh - 24px);\n    overflow-y: auto;\n  }\n\n  .expert-card,\n  .expert-sidebar-card {\n    padding: 20px !important;\n  }\n}\n\n/* --------------------------------------------------------------------------\n   13. Wide content scrolls inside its own box rather than the page\n   -------------------------------------------------------------------------- */\n@media (max-width: 991.98px) {\n  [style*=\"overflow-x: auto\"] {\n    -webkit-overflow-scrolling: touch;\n  }\n\n  table {\n    max-width: 100%;\n  }\n\n  pre,\n  code {\n    white-space: pre-wrap;\n    word-break: break-word;\n  }\n}\n\n/* --------------------------------------------------------------------------\n   14. Admin shell\n\n   The sidebar is `position: fixed; width: 270px` with the main column pushed\n   over by an equal margin. On a 375px screen that leaves ~105px of content.\n   AdminLayout now drives these classes to run the sidebar as a drawer.\n   -------------------------------------------------------------------------- */\n@media (max-width: 991.98px) {\n  .admin-shell {\n    display: block !important;\n  }\n\n  .admin-sidebar {\n    transform: translateX(-100%);\n    transition: transform 0.28s ease !important;\n    width: 270px !important;\n  }\n\n  .admin-shell.admin-sidebar-open .admin-sidebar {\n    transform: translateX(0);\n  }\n\n  .admin-main {\n    margin-left: 0 !important;\n  }\n\n  .admin-topbar {\n    padding: 0 16px !important;\n    /* Below the drawer backdrop (999). At an equal z-index the topbar is the\n       later element in the DOM and would show through the dim overlay. */\n    z-index: 998 !important;\n  }\n\n  .admin-content {\n    padding: 20px 16px !important;\n  }\n\n  .admin-sidebar-backdrop {\n    position: fixed;\n    inset: 0;\n    background: rgba(10, 22, 40, 0.5);\n    z-index: 999;\n  }\n}\n\n@media (min-width: 992px) {\n  .admin-sidebar-toggle,\n  .admin-sidebar-backdrop {\n    display: none !important;\n  }\n}\n\n/* --------------------------------------------------------------------------\n   15. Footer\n   -------------------------------------------------------------------------- */\n@media (max-width: 767.98px) {\n  .footer-area .row > [class*=\"col-\"] {\n    margin-bottom: 28px;\n  }\n\n  .footer-area .row > [class*=\"col-\"]:last-child {\n    margin-bottom: 0;\n  }\n\n  .footer-bottom {\n    text-align: center;\n  }\n}\n\n/* --------------------------------------------------------------------------\n   16. Typography ceilings\n\n   A few headings are hard-coded at 28-44px inline. clamp() would be better at\n   the source, but these keep long words from forcing a scrollbar meanwhile.\n   -------------------------------------------------------------------------- */\n@media (max-width: 575.98px) {\n  h1 {\n    font-size: min(2rem, 9vw);\n  }\n\n  h2 {\n    font-size: min(1.75rem, 8vw);\n  }\n\n  h3 {\n    font-size: min(1.5rem, 7vw);\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  p,\n  span,\n  a {\n    overflow-wrap: break-word;\n  }\n}\n\n/* --------------------------------------------------------------------------\n   17. Home screen: compact cards\n\n   Every home section was laid out for a desktop column and then handed the\n   full width of a phone: one 380px-tall expert portrait per screenful, one\n   stat tile with a 46px numeral, an event row whose date block, title and type\n   pill all fought for 340px. The markup now puts experts and stats two to a\n   row on phones; the sizes below are what make two-up actually fit.\n   -------------------------------------------------------------------------- */\n@media (max-width: 767.98px) {\n  /* Sections are individually padded inline at clamp(48px, 6vw, 72px); the\n     lower bound is still a lot of dead space between short cards. */\n  .home-card-grid > [class*=\"col-\"] {\n    margin-bottom: 14px !important;\n  }\n}\n\n@media (max-width: 575.98px) {\n  /* Portrait cards: shorter, and the plate carries the name only. Everything\n     else lives behind the tap — see the note at the top of PersonCard.jsx. */\n  /* Taller than it is wide, so the crop is portrait-shaped and a headshot\n     has room to be a headshot: ~152x209 on a 360px phone. */\n  .person-card {\n    height: clamp(200px, 58vw, 260px) !important;\n    border-radius: 8px;\n  }\n\n  .person-card__plate {\n    padding: 8px 12px 10px !important;\n  }\n\n  /* At two per row the card is ~150px wide on a 360px phone. A single\n     ellipsised line turns most names into \"Mukund Sahasrab…\", so the name\n     wraps to two lines — the plate is only carrying the name here, so it can\n     afford the second one without creeping up over the face. */\n  .person-card__name {\n    font-size: 14px !important;\n    line-height: 1.25;\n    white-space: normal !important;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n  }\n\n  .person-card__badge {\n    top: 8px !important;\n    left: 8px !important;\n    padding: 4px 8px !important;\n    font-size: 8px !important;\n  }\n\n  .person-card__monogram {\n    font-size: 40px !important;\n  }\n\n  /* Stat tiles: two per row, so the padding and numeral both come down. */\n  .home-stat-card {\n    padding: 18px 10px !important;\n    border-radius: 12px !important;\n  }\n\n  .home-stat-card .count {\n    font-size: 30px !important;\n    margin-bottom: 4px !important;\n  }\n\n  .home-stat-card p {\n    font-size: 10px !important;\n    letter-spacing: 1px !important;\n    line-height: 1.35;\n  }\n\n  /* Event rows: the date block and the type pill move onto one line under the\n     title instead of squeezing it into a third of the width. */\n  .home-events-list {\n    gap: 12px !important;\n  }\n\n  .home-event-card {\n    align-items: flex-start !important;\n    flex-wrap: wrap;\n    gap: 12px !important;\n    padding: 14px 14px !important;\n    border-radius: 10px;\n  }\n\n  .home-event-date {\n    width: 52px !important;\n    height: 52px !important;\n    border-radius: 10px !important;\n  }\n\n  .home-event-date span:first-child {\n    font-size: 18px !important;\n  }\n\n  .home-event-date span:last-child {\n    font-size: 9px !important;\n    letter-spacing: 1px !important;\n  }\n\n  .home-event-body {\n    /* Without a basis the flex child refuses to wrap a long venue name. */\n    flex: 1 1 60% !important;\n    min-width: 0;\n  }\n\n  .home-event-body h4 {\n    font-size: 15px !important;\n    margin-bottom: 4px !important;\n  }\n\n  .home-event-body p {\n    font-size: 11px !important;\n  }\n\n  .home-event-type {\n    flex: 1 1 100%;\n  }\n\n  .home-event-type span {\n    padding: 5px 12px !important;\n    font-size: 9px !important;\n    letter-spacing: 1px !important;\n  }\n\n  /* Testimonials: one per row, but not with desktop padding. */\n  .home-testimonial-col > div {\n    padding: 18px 16px !important;\n  }\n}\n\n/* --------------------------------------------------------------------------\n   18. Touch feedback\n\n   suppressTouchHover.js stops tapped cards latching into a hover state, which\n   leaves them with no press feedback at all. These :active rules put it back —\n   a quick, cheap depress that ends the moment the finger lifts, unlike a\n   JavaScript hover flag that has nothing to switch it off.\n   -------------------------------------------------------------------------- */\n@media (hover: none) {\n  .person-card,\n  .home-event-card,\n  .home-stat-card,\n  .btn,\n  button:not(:disabled),\n  [role=\"button\"] {\n    -webkit-tap-highlight-color: rgba(198, 169, 98, 0.18);\n  }\n\n  .person-card:active,\n  .home-event-card:active,\n  .home-stat-card:active {\n    transform: scale(0.985) !important;\n    transition: transform 0.12s ease !important;\n  }\n\n  .btn:active,\n  button:not(:disabled):active {\n    transform: scale(0.97);\n    transition: transform 0.12s ease;\n  }\n\n  /* The person cards deliberately do NOT reopen their detail plate here: it\n     is tall enough to cover the face. The card is a link to the full profile,\n     which is where the role, company and bio belong on a phone. */\n}\n\n/* --------------------------------------------------------------------------\n   19. Notch and home-indicator safe areas\n\n   Fixed elements sat under the iOS home indicator and behind the notch in\n   landscape. env() resolves to 0 everywhere else, so this is inert on Android\n   and desktop.\n   -------------------------------------------------------------------------- */\n@supports (padding: max(0px)) {\n  @media (max-width: 991.98px) {\n    body {\n      padding-bottom: env(safe-area-inset-bottom);\n    }\n\n    .admin-topbar {\n      padding-top: max(12px, env(safe-area-inset-top));\n    }\n  }\n\n  /* Matches the 16px gutter set in section 2, so only the notch adds to it. */\n  @media (max-width: 575.98px) {\n    .container,\n    .custom-container {\n      padding-left: max(16px, env(safe-area-inset-left));\n      padding-right: max(16px, env(safe-area-inset-right));\n    }\n  }\n}\n\n/* --------------------------------------------------------------------------\n   20. Directory cards at two per row\n\n   The experts, advisory and partner grids now use col-6 on phones (they were\n   full width, one card per screenful). Section 17 already sizes the person\n   cards; this does the same for the partner card, whose logo and company name\n   have no room to sit side by side in a 150px column.\n   -------------------------------------------------------------------------- */\n@media (max-width: 575.98px) {\n  .partner-card {\n    padding: 12px !important;\n    gap: 8px !important;\n  }\n\n  .partner-card__head {\n    align-items: flex-start !important;\n    flex-direction: column;\n    gap: 8px !important;\n  }\n\n  .partner-card__head > div:first-child {\n    width: 40px !important;\n    height: 40px !important;\n  }\n\n  .partner-card h5 {\n    font-size: 13px !important;\n  }\n\n  .partner-card p {\n    font-size: 11px !important;\n    line-height: 1.5 !important;\n    -webkit-line-clamp: 2 !important;\n  }\n\n  .partner-card span {\n    font-size: 10px !important;\n  }\n}\n\n/* --------------------------------------------------------------------------\n   21. Admin tables scroll instead of crushing\n\n   The admin lists are five to eight column tables inside a card that carries\n   `overflow: hidden` inline for its rounded corners. On a phone that clipped\n   the table and squeezed every column to a couple of characters, with no way\n   to reach the rest of the row. The card now scrolls sideways and the table\n   keeps a readable minimum width.\n   -------------------------------------------------------------------------- */\n@media (max-width: 991.98px) {\n  .admin-table-wrap {\n    overflow-x: auto !important;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .admin-table {\n    min-width: 760px;\n  }\n\n  .admin-table th,\n  .admin-table td {\n    white-space: nowrap;\n  }\n}\n\n@media (max-width: 575.98px) {\n  /* Admin cards in a two-up grid: the inline padding is desktop-sized. */\n  .admin-content [style*=\"border-radius: 8px\"][style*=\"padding\"] {\n    overflow-wrap: break-word;\n  }\n\n  /* Dialogs on admin screens are 720px wide with 28px of padding, which leaves\n     a phone about 280px of usable form. */\n  .admin-content + div [style*=\"max-width: 720px\"],\n  [style*=\"z-index: 9999\"] > [style*=\"max-width: 720px\"] {\n    padding: 18px !important;\n    max-height: 92vh !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
